import { createReducer, on } from "@ngrx/store";
import * as SalesActions from "./sales.actions";
import { initialSalesState, SalesState } from "./sales.state";

export const salesReducer = createReducer(
  initialSalesState,

  // 🔹 Header updates
  on(SalesActions.updateSalesHeader, (state, { header }) => ({
    ...state,
    header: { ...state.header, ...header },
  })),

  // 🔹 Add item row
  on(SalesActions.addSalesItem, (state, { item }) => ({
    ...state,
    items: [...state.items, item],
  })),

  // 🔹 Update item row
  on(SalesActions.updateSalesItem, (state, { index, item }) => {
    const updatedItems = [...state.items];
    updatedItems[index] = item;
    return { ...state, items: updatedItems };
  }),

  // 🔹 Remove item row
  on(SalesActions.removeSalesItem, (state, { index }) => {
    const updatedItems = [...state.items];
    updatedItems.splice(index, 1);
    return { ...state, items: updatedItems };
  }),

  // 🔹 Clear all item rows
  on(SalesActions.clearSalesItems, (state) => ({
    ...state,
    items: [],
  })),

  // 🔹 FIFO batch split — replace 1 row with many
  on(
    SalesActions.getFifoSplitBatchesSuccess,
    (state, { rowIndex, splitItems }) => {
      const updatedItems = [...state.items];
      updatedItems.splice(rowIndex, 1, ...splitItems);
      return { ...state, items: updatedItems };
    }
  ),

  // 🔹 Summary update
  on(SalesActions.updateSalesSummary, (state, { summary }) => ({
    ...state,
    summary,
  })),

  // 🔹 Reset entire sales form
  on(SalesActions.resetSalesForm, () => initialSalesState),

  on(SalesActions.createSales, (state) => ({
    ...state,
    loading: true,
    saveSuccess: false,
    saveError: null,
  })),

  on(SalesActions.createSalesSuccess, (state, { invoice }) => ({
    ...state,
    loading: false,
    saveSuccess: true,
    invoice,
  })),

  on(SalesActions.createSalesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    saveSuccess: false,
    saveError: error,
  })),

  on(SalesActions.clearSalesForm, (state) => ({
    ...state,
    loading: false,
    saveSuccess: false,
    saveError: null,
    items: [],
    header: null,
  })),

  on(SalesActions.searchSalesItems, (state) => ({
    ...state,
    loading: true,
    itemSearchError: null,
  })),

  on(SalesActions.searchSalesItemsSuccess, (state, { items, rowIndex }) => ({
    ...state,
    searchResultsByRow: {
      ...state.searchResultsByRow,
      [rowIndex]: items,
    },
    loading: false,
  })),

  on(SalesActions.searchSalesItemsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    itemSearchError: error,
  })),
  
  on(SalesActions.clearSaleSearchItems, (state) => ({
    ...state,
    searchResultsByRow: {},
  }))
);
